import {useState} from 'react';
import Cookies from 'js-cookie';
import {PostData, UseCreatePostResult} from "../types/api";

const useCreatePost = (): UseCreatePostResult => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [data, setData] = useState<any>(null);

    const createPost = async (postData: PostData) => {
        setIsLoading(true);
        setError(null);

        try {
            const formData = new FormData();

            // Добавляем текстовые поля
            formData.append('title', postData.title);
            formData.append('content', postData.content);
            formData.append('excerpt', postData.excerpt || '');
            formData.append('category_id', postData.category || '');
            formData.append('authorId', postData.authorId.toString());
            formData.append('tags', postData.tags.toString());

            // Добавляем изображения и их подписи
            const captions: string[] = [];

            for (const image of postData.images) {
                // Если image.file - это объект File, добавляем его
                if (image.file instanceof File) {
                    formData.append('images', image.file);
                    captions.push(image.caption || '');
                }
                // Если image.file - это строка (data URL), преобразуем в Blob
                else if (typeof image.file === 'string' && image.file.startsWith('data:')) {
                    const response = await fetch(image.file);
                    const blob = await response.blob();
                    const file = new File([blob], `image_${Date.now()}.jpg`, {type: blob.type});
                    formData.append('images', file);
                    captions.push(image.caption || '');
                }
            }

            // Добавляем подписи как отдельное поле
            formData.append('image_captions', captions.toString());

            // Получаем access_token из куки
            const accessToken = Cookies.get('access_token');

            if (!accessToken) {
                throw new Error('Требуется авторизация. Пожалуйста, войдите в систему.');
            }

            const apiUrl = process.env.REACT_APP_API_BASE || '/api';

            const response = await fetch(`${apiUrl}/post/`, {
                method: 'POST',
                body: formData,
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                }
            });
            console.log(formData)
            if (!response.ok) {
                if (response.status === 401) {
                    // Токен недействителен, удаляем его
                    Cookies.remove('access_token');
                    throw new Error('Сессия истекла. Пожалуйста, войдите снова.');
                }

                const errorText = await response.text();
                throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
            }

            const result = await response.json();
            setData(result);
            return result;
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : 'Неизвестная ошибка';
            setError(errorMessage);
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    return {createPost, isLoading, error, data};
};

export default useCreatePost;